import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1f400d00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "inner-dot" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "event-date" }
const _hoisted_5 = { class: "event-details" }
const _hoisted_6 = {
  key: 0,
  class: "event-tag"
}
const _hoisted_7 = {
  key: 1,
  class: "event-tag"
}
const _hoisted_8 = { class: "event-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlmStatusBadge = _resolveComponent("AlmStatusBadge")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Timeline, {
      value: _ctx.events,
      align: "left"
    }, {
      marker: _withCtx((slotProps) => [
        _createElementVNode("span", {
          class: _normalizeClass(["dot-wrapper", {
                        'dot-start': slotProps.item.type === 'Start',
                        'dot-end': slotProps.item.type === _ctx.STATUS.READY,
                        'dot-deploying': slotProps.item.type === _ctx.STATUS.DEPLOYING,
                        'dot-failed': slotProps.item.type === _ctx.STATUS.FAILED,
                        'dot-queued': slotProps.item.type === _ctx.STATUS.QUEUED,
                    }])
        }, _hoisted_3, 2)
      ]),
      content: _withCtx((slotProps) => [
        _createElementVNode("div", {
          class: _normalizeClass(slotProps.item.type === 'Start' ? 'event-card-start' : 'event-card')
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(slotProps.item.date), 1),
          _createElementVNode("div", _hoisted_5, [
            (slotProps.item.type === 'Start')
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Start_Tag_Text')), 1))
              : (slotProps.item.type === 'Ready')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_End_Tag_Text')), 1))
                : (_openBlock(), _createBlock(_component_AlmStatusBadge, {
                    key: 2,
                    params: { value: slotProps.item.type }
                  }, null, 8, ["params"])),
            _createElementVNode("span", _hoisted_8, _toDisplayString(slotProps.item.label), 1)
          ])
        ], 2)
      ]),
      connector: _withCtx((slotProps) => [
        _createElementVNode("div", {
          class: "p-timeline-event-connector",
          style: _normalizeStyle({ backgroundColor: _ctx.getConnectorColor(slotProps.item.type) })
        }, null, 4)
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}